export class LandingTrackingSettingsEntity {
  isEnabled: boolean

  googleTagManagerId: string | null

  googleAnalyticsMeasurementId: string | null

  googleAdsConversionId: string | null

  metaPixelId: string | null

  enableAutomaticPageView: boolean

  showLeadCaptureForm: boolean

  constructor(value: Partial<LandingTrackingSettingsEntity> = {}) {
    this.isEnabled = value?.isEnabled ?? false

    this.googleTagManagerId = value?.googleTagManagerId ?? null

    this.googleAnalyticsMeasurementId = value?.googleAnalyticsMeasurementId ?? null

    this.googleAdsConversionId = value?.googleAdsConversionId ?? null

    this.metaPixelId = value?.metaPixelId ?? null

    this.enableAutomaticPageView = value?.enableAutomaticPageView ?? true

    this.showLeadCaptureForm = value?.showLeadCaptureForm ?? true
  }
}
